export default __webpack_public_path__ + "static/media/bateria.f8e4dd9f.png";